import React, { useState } from "react";
import InsightsSideBar from "../../../InsightsSideBar";
import { useReports } from "./hooks/useReports";
import { useDownloadExcel } from "./hooks/useDownloadExcel";
import { ReportLayout } from "../../../components/ReportLayout/ReportLayout";
import { Header } from "./components/Header";
import { Table } from "./components/Table";
import { ModalFilter } from "./components/ModalFilter";
import { usePrefill } from "./hooks/usePrefill";

export function RetentionRateDetailsReport() {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const { reports, filter, order, period } = useReports();

  const downloadExcel = useDownloadExcel({
    period,
    filter: filter.preparedForRequest,
    order,
  });

  usePrefill({ filter, period });

  return (
    <div id="content">
      <div className="container-fluid content setting-wrapper">
        <InsightsSideBar />
        <div className="memberWalletOuter business-section">
          <ReportLayout>
            <Header
              period={period}
              onFilterOpen={() => setIsFilterOpen(true)}
              downloadExcel={downloadExcel}
              isReportsLoading={reports.isLoading}
              isFilterActive={filter.isActive}
            />
            <Table reports={reports} order={order} />
            <ModalFilter
              isOpen={isFilterOpen}
              onClose={() => setIsFilterOpen(false)}
              filter={filter}
            />
          </ReportLayout>
        </div>
      </div>
    </div>
  );
}
